export default "__VITE_ASSET__BmyOxmAc__"